/**
 * @user: antes
 * @emial: tangzhlyd@gmail.com
 * @data: 2020/7/20 下午2:45
 */
import login from "@/views/login";
import { NotFound } from "@/views/NotFound";
import Children from "@/router/Children";
import { lazy } from "react";
import Layout from "@/Layout";
export const routesOther: Array<Rantion.RouteConfig> = [
  {
    path: "/task",
    component: Layout,
    meta: { title: "工作流" },
    name: "Task",
    children: [
      {
        path: "wait",
        component: lazy(() => import("@/views/task/waittask")),
        meta: { title: "待办任务" },
        name: "Waittask",
      },
      {
        path: "todo",
        component: lazy(() => import("@/views/task/iam-todo")),
        meta: { title: "新版待办任务" },
        name: "Todo",
      },
      {
        path: "warning",
        component: lazy(() => import("@/views/task/warningtask")),
        meta: { title: "警报任务" },
        name: "Warningtask",
      },
      {
        path: "already",
        component: lazy(() => import("@/views/task/alreadytask")),
        meta: { title: "已任务" },
        name: "Alreadytask",
      },
    ],
  },
  {
    path: "/costmg",
    component: Layout,
    meta: { title: "费用管理" },
    name: "Costmg",
    children: [
      {
        path: "invoice",
        component: lazy(() => import("@/views/costmg/invoice")),
        meta: { title: "费用请款单" },
        name: "CostmgInvoice",
      },
      {
        path: "payment-bank",
        component: lazy(() => import("@/views/costmg/payment-bank")),
        meta: { title: "付款银行管理" },
        name: "PaymentBank",
      },
    ],
  },
  {
    path: "/basics",
    component: Layout,
    meta: { title: "基础信息" },
    name: "Basics",
    children: [
      {
        path: "supplyChain",
        component: Children,
        meta: { title: "供应链" },
        name: "SupplyChain",
        children: [
          {
            path: "centerId",
            component: lazy(() => import("@/views/basics/supplyChain/centerid")),
            meta: { title: "centerId & shipTo" },
            name: "CenterShip",
          },
          {
            path: "country",
            component: Children,
            meta: { title: "国家资料" },
            name: "Country",
            children: [
              {
                path: "list",
                component: lazy(() => import("@/views/basics/supplyChain/country/list")),
                meta: { title: "国家列表" },
                name: "CountryType",
              },
              {
                path: "state",
                component: lazy(() => import("@/views/basics/supplyChain/country/state")),
                meta: { title: "州" },
                name: "StateList",
              },
              {
                path: "area",
                component: lazy(() => import("@/views/basics/supplyChain/country/area")),
                meta: { title: "区县" },
                name: "AreaList",
              },
              {
                path: "city",
                component: lazy(() => import("@/views/basics/supplyChain/country/city")),
                meta: { title: "城市" },
                name: "CityList",
              },
            ],
          },
          {
            path: "mainBody",
            component: lazy(() => import("@/views/basics/supplyChain/mainBody")),
            meta: { title: "主体信息" },
            name: "MainBody",
          },
          {
            path: "versionUpdate",
            component: lazy(() => import("@/views/basics/supplyChain/versionUpdate")),
            meta: { title: "版本更新" },
            name: "VersionUpdated",
          },
          {
            path: "shopDepartment",
            component: lazy(() => import("@/views/basics/supplyChain/shopDepartment")),
            meta: { title: "店铺 & 事业部" },
            name: "ShopDepartmentMap",
          },
          {
            path: "basicConfig",
            component: lazy(() => import("@/views/basics/supplyChain/basicConfig")),
            meta: { title: "数据字典" },
            name: "BasicConfig",
          },
          {
            path: "holiday",
            component: lazy(() => import("@/views/basics/supplyChain/holiday")),
            meta: { title: "节假日日期设置" },
            name: "Holiday",
          },
        ],
      },
      {
        path: "marketingServices",
        component: Children,
        meta: { title: "营销服务" },
        name: "MarketingServices",
        children: [
          {
            path: "tags",
            component: lazy(() => import("@/views/basics/marketingServices/tags")),
            meta: { title: "标签管理" },
            name: "Tags",
          },
          {
            path: "platformShop",
            component: Children,
            meta: { title: "平台店铺" },
            name: "ShopAndPlatform",
            children: [
              {
                path: "channel",
                component: lazy(
                  () => import("@/views/basics/marketingServices/platformShop/channel"),
                ),
                meta: { title: "渠道" },
                name: "Channel",
              },
              {
                path: "platform",
                component: lazy(
                  () => import("@/views/basics/marketingServices/platformShop/platform"),
                ),
                meta: { title: "平台" },
                name: "Platform",
              },
              {
                path: "site",
                component: lazy(() => import("@/views/basics/marketingServices/platformShop/site")),
                meta: { title: "站点" },
                name: "Site",
              },
              {
                path: "list",
                component: lazy(() => import("@/views/basics/marketingServices/platformShop/list")),
                meta: { title: "平台店铺" },
                name: "PlatformShop",
              },
              {
                path: "platformAccount",
                component: lazy(
                  () => import("@/views/basics/marketingServices/platformShop/platformAccount"),
                ),
                meta: { title: "平台对接账号" },
                name: "PlatformAccount",
              },
              {
                path: "siteShop",
                component: lazy(
                  () => import("@/views/basics/marketingServices/platformShop/siteShop"),
                ),
                meta: { title: "平台站点店铺" },
                name: "SiteShop",
              },
            ],
          },
          {
            path: "customerInfo",
            component: Children,
            meta: { title: "客户信息" },
            name: "CustomerInfo",
            children: [
              {
                path: "toB",
                component: lazy(() => import("@/views/basics/marketingServices/customerInfo/toB")),
                meta: { title: "ToB客户" },
                name: "ToB",
              },
            ],
          },
          {
            path: "msku",
            component: lazy(() => import("@/views/basics/marketingServices/msku")),
            meta: { title: "MSKU映射" },
            name: "MSKU",
          },
          {
            path: "sales-quotation",
            component: lazy(() => import("@/views/basics/marketingServices/sales-quotation")),
            meta: { title: "销售报价" },
            name: "SalesQuotation",
          },
        ],
      },
      {
        path: "finance",
        component: Children,
        meta: { title: "财务" },
        name: "Finance",
        children: [
          {
            path: "bankInfo",
            component: lazy(() => import("@/views/basics/finance/bankInfo")),
            meta: { title: "银行信息" },
            name: "BankInfo",
          },
          {
            path: "privateAccount",
            component: lazy(() => import("@/views/basics/finance/privateAccount")),
            meta: { title: "对私账户" },
            name: "PrivateAccount",
          },
          {
            path: "costMapping",
            component: lazy(() => import("@/views/basics/finance/costMapping")),
            meta: { title: "费用项映射" },
            name: "CostMapping",
          },
          {
            path: "revenue",
            component: lazy(() => import("@/views/basics/finance/revenue")),
            meta: { title: "受益部门" },
            name: "Revenue",
          },
          {
            path: "cost-center",
            component: lazy(() => import("@/views/basics/finance/cost-center")),
            meta: { title: "成本中心" },
            name: "CostCenter",
          },
          {
            path: "amazonRange",
            component: lazy(() => import("@/views/basics/finance/amazonRange")),
            meta: { title: "月度报表分组" },
            name: "AmazonRange",
          },
          {
            path: "financialAccountMapping",
            component: lazy(() => import("@/views/basics/finance/financialAccountMapping")),
            meta: { title: "财务科目映射" },
            name: "FinancialAccountMapping",
          },
        ],
      },
      {
        path: "params",
        component: Children,
        meta: { title: "全局参数" },
        name: "Params",
        children: [
          {
            path: "paramsList",
            component: lazy(() => import("@/views/basics/params/paramsList")),
            meta: { title: "全局参数" },
            name: "ParamsList",
          },
        ],
      },
      {
        path: "authmg",
        component: Children,
        meta: { title: "授权管理" },
        name: "AuthMg",
        children: [
          {
            path: "log",
            component: lazy(() => import("@/views/basics/authmg/log")),
            meta: { title: "授权记录" },
            name: "AuthMgLog",
          },
        ],
      },
    ],
  },
  {
    path: "/device",
    component: Layout,
    meta: { title: "固件管理" },
    name: "Device",
    children: [
      {
        path: "sku",
        component: lazy(() => import("@/views/device/sku")),
        meta: { title: "SKU固件" },
        name: "DeviceSku",
      },
      {
        path: "version",
        component: lazy(() => import("@/views/device/version")),
        meta: { title: "版本" },
        name: "DeviceVersion",
      },
      {
        path: "list",
        component: lazy(() => import("@/views/device/list")),
        meta: { title: "型号" },
        name: "DeviceList",
      },
    ],
  },
];
export const routes: Array<Rantion.RouteConfig> = [
  {
    path: "/login",
    component: login,
    notLogin: true,
    meta: { title: "登录" },
    name: "login",
  },
  {
    path: "/404",
    component: NotFound,
    meta: {
      title: "404",
    },
    name: "404",
    notLogin: true,
  },
  {
    path: "/*",
    component: lazy(() => import("@/views/App")),
    meta: { title: "erp" },
    name: "erp",
    children: routesOther,
  },
];
